var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTip)?_c('p',[_c('a',{attrs:{"href":"https://futu.feishu.cn/wiki/wikcn4Wgwnr3vuxNvLNWAPMeRjd","target":"_blank"}},[_vm._v("\n        如需上报奖励中心需使用请先关联活动！！\n    ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }